<!--
    チェックボックスコンポーネント
    props: {
        val: ボタンに紐づく値(Number型)
        checkedValue: 現在押されているボタンの値(Number型)
    }

-->
<template>
  <div>
    <input
      type="checkbox"
      :checked="val === checkedValue"
      @click="checkboxClick"
      :data-test="val"
    />
    <label class="checkbox-label">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    val: {
      type: Number,
      required: true
    },
    checkedValue: {
      type: Number,
      required: true
    }
  },
  methods: {
    checkboxClick: function() {
      this.$emit("toggle", this.val);
    }
  }
};
</script>

<style scoped>
.checkbox-label {
  margin-left: 10px;
}
</style>
